module.exports = __webpack_public_path__ + "static/media/logo-branca.9fcef6d5.png";